<template>
  <div class='main-container'>
    <div v-if="status=='notSign'">
    <div class="top">
      <div class="head">
        <span class="title">请选择要使用的印章</span>
<!--        <div class="sign-guide">-->
<!--          <div class="guide-content">-->
<!--            <el-popover placement="bottom" title="操作步骤" width="245" trigger="hover" content="">-->
<!--              <div>-->
<!--                1、选择下方要使用的印章。<br>-->
<!--                2、点击右上角确认签署，开始批量签署。-->
<!--              </div>-->
<!--              <div slot="reference" class="guide-detail">-->
<!--                <svg-icon iconClass="icon-warning" width="16" height="16" style="margin-right: 8px;"></svg-icon>-->
<!--                操作指引-->
<!--              </div>-->
<!--            </el-popover>-->
<!--          </div>-->
<!--        </div>-->
        <div style="margin-left: auto">
          <el-button size="small" type="primary" :disabled="!selectSingData.length" @click="signBtn">
            确认签署
          </el-button>
        </div>
      </div>
    </div>
    <div class="auto-seal-wrap">
        <div class="auto-seal-list">
          <div v-for="item in sealInfoArray" :key="item.sealId" class="auto-seal-item"
               @click="handleSelectAutoSeal(item,sealInfoArray)">
            <div class="select-sign" :data-seal-type="item.sealType" :class="{ 'isCheck': item.check }">
								<span v-if="item.sealType !== 'date'">
									<span class="tag process" v-if="item.permissionType == 'process'">需审批</span>
									<span class="tag authed" v-if="item.permissionType == 'authed'">已授权</span>
									<span class="tag forbid" v-if="item.permissionType == 'disabled'">不可用</span>
								</span>
              <div class="sign-item" data-type="sign" :data-seal-type="item.sealType"
                   :data-seal-id="item.sealId">
                <img :src="item.sealImg" alt="" ondragstart="return false" />
              </div>
              <i class="check-fill" v-if="item.check">
                <svg-icon iconClass="tick" width="10" height="7.42"></svg-icon>
              </i>
              <i class="check-circle" v-else="item.check"></i>
            </div>
            <div class="seal-name">{{ item.sealName }}</div>
          </div>
        </div>


    </div>
    </div>
    <div class="tip" v-if="status=='signed'">
      <img src="@/assets/images/global/auth-success.png" alt=""/>
      <p class = "suText">签署已完成</p>
      <!--        <p class = "moText">关闭此页面，您可回到网页端继续操作</p>-->
    </div>

    <el-dialog :close-on-click-modal="false" :append-to-body="true" class="auth-dialog" title="签署密码验证"
               :visible.sync="dialogVisible" width="400px" @close="cancel">
            <el-form @submit.native.prevent :model="pinForm" :rules="pinRules" ref="pinForm" class="pin-Form">
              <el-form-item prop="pin" style="position:relative;margin-bottom: 0">
                <el-input size="small" placeholder="输入签署密码（6位数字）" show-word-limit maxlength="6" type="password" v-model="pinForm.pin"></el-input>
                <div class="alert">{{pinCodeMsg}}</div>
              </el-form-item>
            </el-form>



      <div class="dialog-btns" slot="footer">
        <el-button size="small" @click="cancel">取消</el-button>
        <el-button size="small" type="primary" @click="submitHandle" class="btn-ok">确认</el-button>

      </div>
    </el-dialog>

  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from ‘《组件路径》‘;
import {getSealListBySignId, formsignSign} from '@/api/sign/sign'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    return {
      signId:'',
      sealInfoArray:[],
      positionSeal: {
        companyCommon: '',//	非必填	string	企业公章
        companyLegal: '',//	非必填	string	企业法定代表人章
        companyAgent: '',//	非必填	string	企业经办人个人章
        person: '',//	非必填	string	个人手写章
        date: '',//	非必填	string	日期章
      },
      selectSingData: [],
      dialogVisible:false,
      pinForm: {
        pin: ""
      },
      pinRules: {
        pin: [
          {
            required: true,
            message: "请输入签署密码",
            trigger: "blur"
          }
        ]
      },
      pinCodeMsg:undefined,
      status:undefined
    };
  },
  computed: {},
  watch: {},
  created() {
    this.signId=this.$route.query.signId;
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail(){
      getSealListBySignId({
        signId: this.signId,
      }).then((res) => {
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          this.sealInfoArray=res.data.sealInfoArray;
          this.status=res.data.status;
        }
      })
    },
    handleSelectAutoSeal(item, list) {
      list.map(_item => {
        if (item === _item) {
          this.$set(item, 'check', !item.check);
          if(item.check){
            this.positionSeal[item.sealType] = item.sealId;
            // !this.positionSeal[item.sealType] &&
            if (!this.selectSingData.length && !this.selectSingData.includes(item.sealId)) {
              this.selectSingData.push(item.sealId);
            }else{
              this.selectSingData.splice(this.selectSingData.indexOf(this.positionSeal[item.sealType]), 1,item.sealId);

            }
          }else{
            this.selectSingData.splice(this.selectSingData.indexOf(this.positionSeal[item.sealType]), 1)
            this.positionSeal[item.sealType] = "";
          }
        } else {
          this.$set(_item, 'check', false);
        }
      });

    },
    signBtn(){
      this.dialogVisible=true;

    },
    submitHandle(){
      this.$refs["pinForm"].validate(valid => {
        if (valid) {
          formsignSign({
            pin: this.pinForm.pin,
            sealId: this.selectSingData[0],
            signId: this.signId
          }).then(res => {
            if (res.code != "200") {
                if(res.code==5001){
                  this.pinCodeMsg=res.message;
                }else{
                  this.$message({
                    showClose: true,
                    message: res.message,
                    type: "warning",
                  });
                }

            } else {
              // this.$message({
              // 	showClose: true,
              // 	message: res.message,
              // 	type: "success"
              // });
              this.cancel();
              this.getDetail();
            }
          });
        } else {
          console.log("error submit!");
          return false;
        }
      });
    },
    cancel() {
      this.dialogVisible = false;
      this.pinForm.pin = "";
      this.pinCodeMsg=undefined;
    }
  },

}
</script>
<style scoped lang="scss">
.main-container{
  position: relative;
  background-color: #ffffff;
  min-height: 100vh;
  .top{
    font-size: 16px;
    color: #1d2129;
    font-weight: 600;
    height: 56px;
    margin: 0;
    border-bottom: 1px solid #e7e7e7;
    padding: 0 16px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .head{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .title{
        color: #606266;
        font-size: 15px;
      }
      .sign-guide {
        padding-left: 20px;
        font-size: 12px;
        font-weight: 500;
        color: #4E5969;

        .guide-content {
          font-size: 12px;
          font-weight: 400;
          color: #86909C;
          line-height: 22px;
          position: relative;
        }

        .guide-detail {
          display: flex;
          align-items: center;
        }
      }
    }

  }
  .auto-seal-wrap {
    padding-left: 40px;
    height: calc(100% - 62px);
    overflow: auto;

    .auto-seal-list {
      display: grid;
      grid-gap: 0 40px;
      grid-template-columns: repeat(auto-fit, minmax(180px, 0));
    }

    .auto-seal-item {
      border-radius: 10px;
      position: relative;
      cursor: pointer;

      .seal-name {
        font-size: 13px;
        font-weight: 400;
        color: #424E66;
        margin: 12px auto 16px;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }


      .select-sign {
        width: 180px;
        height: 180px;
        background: #FFFFFF;
        border-radius: 6px 6px 6px 6px;
        border: 1.5px dashed #D8DAEA;
        position: relative;

        i {
          position: absolute;
          right: 10px;
          bottom: 10px;
          color: #468DFF;
          width: 20px;
          height: 20px;
          line-height: 20px;
          background: #FFFFFF;
          border-radius: 50%;
          text-align: center;

          &.check-fill {
            background: #468DFF;
          }

          &.check-circle {
            display: none;
            border: 1.5px solid #3F7BF9;
          }
        }



        &:hover {
          border-color: #3F7BF9;

          i.check-circle {
            display: block;
          }
        }

        &.isCheck {
          border-color: #3F7BF9;
          border-style: solid;
        }

        img {
          max-width: 100%;
          height: auto;
          vertical-align: middle;
          user-select: none;
        }


        &[data-seal-type="companyCommon"] {
          width: 180px;
          height: 180px;
        }

        &[data-seal-type="companyLegal"] {
          width: 180px;
          height: 180px;

          img {
            max-height: 70px;
          }
        }

        &[data-seal-type="companyAgent"] {
          width: 180px;
          height: 180px;

          img {
            max-height: 70px;
          }
        }

        &[data-seal-type="person"] {
          width: 180px;
          height: 180px;

          img {
            max-height: 70px;
          }
        }

        &[data-seal-type="date"] {
          width: 180px;
          height: 180px;

          img {
            max-height: 40px;
          }
        }

        .sign-item {
          width: 140px;
          text-align: center;
          font-size: 0;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: auto;

          img {
            max-width: 100%;
            height: auto;
            vertical-align: middle;
            user-select: none;
          }

          span {
            display: inline-block;
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            margin-top: 5px;
          }
        }

        .tag {
          display: inline-block;
          width: 48px;
          height: 20px;
          line-height: 18px;
          background: #F5FBF5;
          border-radius: 4px 4px 4px 4px;
          text-align: center;
          border: 1px solid #B9E2C6;
          font-size: 12px;
          font-weight: 400;
          position: absolute;
          top: 8px;
          right: 8px;

          &.authed {
            background: #F5FBF5;
            border: 1px solid #B9E2C6;
            color: #38A65A;
          }

          &.process {
            background: #FFF8F9;
            border: 1px solid #FFCACD;
            color: #EB6069;
          }

          &.forbid {
            background: #F2F3F5;
            border: 1px solid #C4CEDB;
            color: #86909C;
          }
        }



      }

    }


  }



}

.auth-nav {
  width: 57px;
  // margin: 0 auto;
}

.auth-nav a {
  color: #999999;
  // font-size: 16px;
  float: left;
  padding-bottom: 5px;
}

.auth-nav a:last-child {
  float: right;
}

.auth-nav a.active {
  border-bottom: 2px solid #3F7BF9;
  color: #3F7BF9;
}


.pin-Form {
  margin: 20px auto 0;
}

.phone-text {
  color: #333333;
  font-size: 14px;
  margin-bottom: 20px;
}

.code-btn {
  position: absolute;
  right: 0;
  top: 0;

  .el-button {
    // height: 38px;
    // padding: 0;
    // width: 100px;
    border-radius: 0 3px 3px 0;
    // border: none;
  }
}

.dialog-btns{
  display: flex;
  justify-content: flex-end;
}
.alert{
  color: #D54941;
  font-size: 12px;
  height: 32px;
}



.tip{
  position: absolute;
  width: 100%;
  text-align: center;
  vertical-align: middle;
  //margin-top: 40%;
  top: 40%;
}

.tip .suText{
  font-size: 16px;
  font-weight: 500;
  color: #3D3D3D;
  margin-top: 20px;
  margin-bottom: 20px;
}

.tip .moText{
  font-size: 12px;
  font-weight: 400;
  color: #86909C;
}
/deep/ .el-dialog__body{
  padding-bottom: 0;
}
</style>
